import React, { useEffect } from "react";
import "./HereOutStories.scss";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import YoutubeIcon from "../../images/youtube.svg";
import { Fancybox } from "@fancyapps/ui";
import PlayStore from "../../images/play-store-rate.svg";
import AppleStore from "../../images/apple-rate.svg";
import YellowStar from "../../images/yellow-star.svg";
import GreyStar from "../../images/grey-star.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const HereOutStories = () => {
  const BikeShowCaseData = [
    {
      video: "https://www.youtube.com/embed/a6S5JB_F3oA",
    },
    {
      video: "https://www.youtube.com/embed/8rjprkY7QkQ",
    },
    {
      video: "https://www.youtube.com/embed/x6PTsyRh_Ek?si=U4LLzKVkut0TOvIG",
    },
  ];

  const getYouTubeThumbnail = (url) => {
    const videoId = url.split("embed/")[1]?.split("?")[0];
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`; // High-quality thumbnail
  };

  useEffect(() => {
    // Bind FancyBox
    Fancybox.bind("[data-fancybox]", {
      Video: {
        autoplay: true,
      },
    });

    // Add FancyBox open event to pause YouTube videos
    document.addEventListener("click", (event) => {
      if (event.target.closest('[data-fancybox="gallery"]')) {
        if (window.pauseYouTubeVideo) {
          window.pauseYouTubeVideo(); // Call the global function to pause YouTube videos
        }
      }
    });

    // Cleanup FancyBox bindings when component unmounts
    return () => Fancybox.destroy();
  }, []);

  const renderStars = (rating, totalStars = 5) => {
    return Array.from({ length: totalStars }, (_, index) =>
      index < rating ? (
        <img
          key={index}
          src={YellowStar}
          alt="yellow star"
          style={{ marginRight: "4px" }}
          className="star-rating"
        />
      ) : (
        <img
          key={index}
          src={GreyStar}
          alt="grey star"
          style={{ marginRight: "4px" }}
          className="star-rating"
        />
      )
    );
  };

  return (
    <section className="here-out section-padding-lg">
      <div className="container">
        <div className="here-out__header section-header">
          <h2>
            Hear out stories{" "}
            <span className="block">
              of <span className="green">MYBYKERS</span>
            </span>
          </h2>
          <div className="here-out__rating">
            <div className="here-out__rating-ps">
              <figure>
                <img src={PlayStore} alt="play-store-logo" />
              </figure>
              {renderStars(4)}
              <span>4.3</span>
            </div>
            <div className="here-out__rating-ps ap">
              <figure>
                <img src={AppleStore} alt="app-store-logo" />
              </figure>
              {renderStars(4)}
              <span>4.2</span>
            </div>
          </div>
        </div>

        <div className="here-out__slider">
          <Swiper
            spaceBetween={0}
            slidesPerView={3}
            loop={false}
            breakpoints={{
              1500: {
                slidesPerView: 3,
              },
              991: {
                loop: false,
                slidesPerView: 3,
              },
              767: {
                slidesPerView: 2.1,
              },
              600: {
                slidesPerView: 1.5,
              },
              320: {
                slidesPerView: 1.5,
              },
              300: {
                slidesPerView: 1.1,
              },
            }}
          >
            {BikeShowCaseData.map((item, index) => (
              <SwiperSlide key={index}>
                <div key={index} className="video-iframe-wrapper">
                  <div className="slider__item">
                    <figure>
                      <div className="video-icon">
                        <img src={YoutubeIcon} alt="" />
                      </div>
                      <a
                        href={item.video}
                        data-fancybox="gallery"
                      >
                        <img
                          src={getYouTubeThumbnail(item.video)}
                          alt={`Video Thumbnail ${index + 1}`}
                          className="video-thumbnail"
                        />
                      </a>
                    </figure>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default HereOutStories;
